export const PARTNER_KEY = 'partner'

export const PARTNER_JAGIS = 'agir'

export const PARTNER_2TONNES = '2-tonnes'
